module.exports = __webpack_public_path__ + "static/media/block.593a806a.svg";